<template>
  <div>
    <table class="calendar-table">
      <tbody>
        <tr>
          <th>{{ fullYear }}</th>
          <th v-for="item in getNextDays(8)" colspan="2">
            {{ moment(item).format('MM.DD') }}
          </th>
        </tr>
        <tr>
          <th></th>
          <template v-for="n in 8">
            <th>DE</th>
            <th>DU</th>
          </template>
        </tr>
        <tr
          :class="(item.IS_ALLANDO_HASZNALAT == 1 || item.IS_VENDEG_PARKOLO == 1) && `allando`"
          v-for="(item, index) in parking"
        >
          <td>{{ item.HELY_AZON }}</td>
          <template v-for="n in 8">
            <td
              @click="handleBook(item, n - 1, 'DE')"
              :class="isTaken(item.ID_PARKOLOHELY, getDayByIndex(n - 1, 8), `DE`).taken ? `taken` : null"
            >
              {{ isTaken(item.ID_PARKOLOHELY, getDayByIndex(n - 1, 8), `DE`).name }}
              <p class="taken-name" v-if="isTaken(item.ID_PARKOLOHELY, getDayByIndex(0, 8), `DE`).taken">
                {{ isTaken(item.ID_PARKOLOHELY, getDayByIndex(n - 1, 8), `DE`).fullname }}
              </p>
            </td>
            <td
              @click="handleBook(item, n - 1, 'DU')"
              :class="isTaken(item.ID_PARKOLOHELY, getDayByIndex(n - 1, 8), `DU`).taken ? `taken` : null"
            >
              {{ isTaken(item.ID_PARKOLOHELY, getDayByIndex(n - 1, 8), `DU`).name }}
              <p class="taken-name" v-if="isTaken(item.ID_PARKOLOHELY, getDayByIndex(n - 1, 8), `DU`).taken">
                {{ isTaken(item.ID_PARKOLOHELY, getDayByIndex(n - 1, 8), `DU`).fullname }}
              </p>
            </td>
          </template>
        </tr>
        <tr>
          <th></th>
          <template v-for="n in 8">
            <th>DE</th>
            <th>DU</th>
          </template>
        </tr>
        <tr>
          <th>{{ fullYear }}</th>
          <th v-for="item in getNextDays(8)" colspan="2">
            {{ moment(item).format('MM.DD') }}
          </th>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'NetvisorCalendar',
  computed: {
    fullYear() {
      return new Date(Date.now()).getFullYear()
    },
    parking() {
      return this.$CORE.sqlParams.parkolohely
    },
    idMunkatars() {
      return this.$CORE.sqlParams.MUNKATARSID[0].ID_MUNKATARS
    },
  },
  methods: {
    moment,
    getDayByIndex(index, num) {
      const dates = []
      for (let i = 0; i < num; i++) {
        dates.push(this.addDays(i))
      }
      return dates[index]
    },
    addDays(days) {
      const today = new Date(Date.now())
      return today.setDate(today.getDate() + days)
    },
    getNextDays(num) {
      const dates = []
      for (let i = 0; i < num; i++) {
        dates.push(this.addDays(i))
      }
      return dates
    },
    isTaken(idParkolohely, date, idoszak) {
      let day = []
      const parkolohelyFoglalas = this.$CORE.sqlParams.parkolohelyFoglalas
      if (idoszak == 'DE') {
        day = parkolohelyFoglalas.filter((foglalas) => {
          return (
            foglalas.ID_PARKOLOHELY == idParkolohely &&
            moment(foglalas.FOGLALAS_NAPJA).format('MM.DD') == moment(date).format('MM.DD') &&
            foglalas.IS_DELELOTT == 1
          )
        })
      }
      if (idoszak == 'DU') {
        day = parkolohelyFoglalas.filter((foglalas) => {
          return (
            foglalas.ID_PARKOLOHELY == idParkolohely &&
            moment(foglalas.FOGLALAS_NAPJA).format('MM.DD') == moment(date).format('MM.DD') &&
            foglalas.IS_DELUTAN == 1
          )
        })
      }
      return {
        taken: day.length > 0,
        name:
          day.length > 0 && day[0].TELJES_NEV
            ? day[0].TELJES_NEV.split(' ')
                .map((entry) => entry.charAt(0))
                .join('')
            : null,
        fullname: day.length > 0 ? day[0].TELJES_NEV : null,
      }
    },
    handleBook(item, idx, amPm, num = 8) {
      const dayIdx = this.getDayByIndex(idx, num)
      const reserved = this.isTaken(item.ID_PARKOLOHELY, dayIdx, amPm)
      const reservedOther = item.IS_ALLANDO_HASZNALAT === 1 || item.IS_VENDEG_PARKOLO === 1
      const bookDate = `${this.fullYear}${moment(this.getDayByIndex(idx, num)).format('.MM.DD')}`

      if (!reserved.taken && !reservedOther) {
        const dialog = confirm('Biztos lefoglalod ' + bookDate + ' dátummal a parkolóhelyet?')
        if (dialog) {
          window.location.href = `/api/ProcessBuilders/run-process?id=6297214555e5910011df1865&ID_PARKOLOHELY=${item.ID_PARKOLOHELY}&date=${bookDate}&${amPm}=true&ID_MUNKATARS=${this.idMunkatars}`
        }
      }
    },
  },
}
</script>
